<template>
    <div>
        <div class="flex flex-wrap m-auto max-w-lg justify-center w-full pt-10">
            <div
                v-for="(link, index) in primaryButtons"
                :key="index"
                class="w-full md:w-1/2"
            >
                <div class="p-2 cursor-pointer">
                    <div
                        class="bg-gray-100 hover:bg-gray-200 border-b-4 border-gray-100 hover:border-blue-600"
                    >
                        <div
                            class="flex flex-col items-center align-center px-12 py-2 w-full"
                            @click="
                                $router.push({
                                    name: link.route,
                                    query: link.params || {}
                                })
                            "
                        >
                            <div class="text-blue-600 mt-4">
                                <img
                                    :src="link.svg"
                                    :alt="link.nombre.toLowerCase()"
                                    class="w-16 h-16 fill-red"
                                />
                            </div>
                            <div
                                class="tracking-tight font-thin uppercase mt-4 text-lg"
                            >
                                {{ link.nombre }}
                            </div>
                            <div
                                class="font-semibold text-gray-800 uppercase mb-4"
                            >
                                {{ link.bajada }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex flex-wrap m-auto max-w-lg justify-center w-full pb-10">
            <div
                v-for="(link, index) in secondaryButtons"
                :key="index"
                class="w-full md:w-1/2"
            >
                <div class="p-2 cursor-pointer">
                    <div
                        class="bg-gray-100 hover:bg-gray-200 border-b-4 border-gray-100 hover:border-blue-600 flex flex-col items-center align-center w-full"
                        @click="
                            $router.push({
                                name: link.route,
                                query: link.params || {}
                            })
                        "
                    >
                        <div
                            class="flex items-center tracking-tight font-thin uppercase mt-4 text-lg"
                        >
                            <div class="text-blue-600 mr-1">
                                <i class="fa-fw" :class="link.icon"></i>
                            </div>
                            <span>{{ link.nombre }}</span>
                        </div>
                        <div class="font-thin text-gray-800 uppercase mb-4">
                            {{ link.bajada }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Home",
    data() {
        return {
            primaryButtons: [
                {
                    route: "agendar",
                    icon: null, //"fas fa-calendar-plus",
                    svg: "svg/calendar-blue.svg",
                    nombre: "Agendar",
                    bajada: "Mantención"
                },
                {
                    route: "agendar",
                    params: { presupuesto: true },
                    icon: null, //"fas fa-calendar-plus",
                    svg: "svg/checklist-blue.svg",
                    nombre: "Agendar",
                    bajada: "Presupuesto"
                }
            ],
            secondaryButtons: [
                {
                    route: "consultar-reserva",
                    icon: "fal fa-search",
                    nombre: "Consultar",
                    bajada: "reserva"
                },
                {
                    route: "anular-reserva",
                    icon: "fal fa-times",
                    nombre: "Anular",
                    bajada: "reserva"
                }
            ]
        };
    }
};
</script>
